import request from '@/utils/request'

export function vip (query) {
  return request({
    url: '/vip/index',
    method: 'get',
    params: query
  })
}

export function isPupo (query) {
  return request({
    url: '/vip/isPupo',
    method: 'get',
    params: query
  })
}
